import moment from "moment-timezone";

import { HITL_TASK_TYPES } from "../../constant/agenticPlatform";

/**
 * Shared row formatters for the Tasks hub sections (screenshots + the two
 * HITL feeds). Kept in one place so the screenshots and HITL tables render
 * patient labels + ages identically.
 */

/**
 * Display label for a patient row: the PHI-hydrated `patientName` followed by
 * the TailorMed patient id in brackets ("First Last (1234)"). Falls back to
 * `Patient #${id}` for non-PHI callers or rows missing PHI data (no redundant
 * trailing id in that case).
 */
export function patientLabel(row) {
  const id = row?.patientId ?? "?";
  if (row?.patientName) return `${row.patientName} (${id})`;
  return `Patient #${id}`;
}

/** Relative "pending since" age, e.g. "3 hours ago". Empty for missing dates. */
export function formatRelativeTime(iso) {
  if (!iso) return "";
  return moment(iso).fromNow();
}

/**
 * The context cell for a HITL row — the mockup's "Reason" (Manual EMR fill) /
 * "State" (Consent) column, derived from the open `human_review` step's
 * `review`:
 *   - emr_fill  → the gathering `exitMode` ("Wrong patient uploaded", …)
 *   - consent   → "Contact info missing" when contact fields are absent,
 *                 otherwise the humanized consent outcome ("Eligible to send")
 * Copy comes from the `agentic_tasks.emr_reason.*` / `agentic_tasks.consent_state.*`
 * i18n keys (en.js owns the labels), keyed by the enum value.
 */
export function hitlContextLabel(item, t) {
  const review = item?.review || {};
  const payload = review.payload || {};

  if (item?.hitlTaskType === HITL_TASK_TYPES.EMR_FILL) {
    const mode = payload.exitMode;
    if (!mode) return "—";
    return t(`agentic_tasks.emr_reason.${mode}`);
  }

  if (item?.hitlTaskType === HITL_TASK_TYPES.CONSENT_DECIDE) {
    if (Array.isArray(payload.missingContactFields) && payload.missingContactFields.length > 0) {
      return t("agentic_tasks.consent_state.contact_missing");
    }
    const outcome = review.outcome || payload.consentOutcome;
    return outcome ? t(`agentic_tasks.consent_state.${outcome}`) : "—";
  }

  return "—";
}
